import CardImg1 from "../../assets/icon-1.png";
import CardImg2 from "../../assets/icon-2.png";
import CardImg3 from "../../assets/icon-3.png";
import CardImg4 from "../../assets/icon-4.png";

const FacilityJsonData = {
  FacilityData: [
    {
      img: CardImg1,
      title: "Varieties Of Coffees",
      pContent: "There Are So Many Popular Types Of Coffee To Choose From",
    },
    {
      img: CardImg2,
      title: "Coffee Beans",
      pContent: "You Will Find Two Types Of Coffee Beans Arabica And Robusta",
    },
    {
      img: CardImg3,
      title: "BreakFast And Sweets",
      pContent: "You Will Love To Choose From Our Sweet BreakFast Recipes",
    },
    {
      img: CardImg4,
      title: "Read To Go Coffee",
      pContent: "Make Your morning Extra Delicious",
    },
  ],
};

export default FacilityJsonData;
